const cssLinks = [
    '/fonts/vendor/@mdi/css/materialdesignicons.min.css',
    '/reservation_process/vue/app.css'
]
cssLinks.forEach(function(url){
    var link = document.createElement( "link" );
    link.href = url;
    link.type = "text/css";
    link.rel = "stylesheet";
    link.media = "screen,print";

    document.getElementsByTagName( "head" )[0].appendChild( link );
})

